import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Heading } from '../../..';
import { HeadingSizeType } from '../../Atoms/Heading/Heading.enum';
import { BaseList, BaseListItem } from './BaseComponents/BaseList';
const Tabs = ({ children, onTabChange }) => {
    const [activeTab, setActiveTab] = useState(0);
    const changeTabHandler = (tabIndex) => {
        setActiveTab(tabIndex);
        if (onTabChange)
            onTabChange(tabIndex);
    };
    return (_jsxs(_Fragment, { children: [_jsx(BaseList, { children: children.map((child, index) => (_jsx(BaseListItem, Object.assign({ active: index === activeTab }, { children: _jsx("button", Object.assign({ "data-testid": `tabButton${index}`, onClick: () => changeTabHandler(index), type: "button" }, { children: _jsx(Heading, Object.assign({ textSize: HeadingSizeType.TITLE18 }, { children: child.props.heading }), void 0) }), void 0) }), child.props.heading))) }, void 0), children[activeTab]] }, void 0));
};
export default Tabs;
//# sourceMappingURL=Tabs.js.map